import { render, staticRenderFns } from "./imprimirCierre.vue?vue&type=template&id=04121a5a"
import script from "./imprimirCierre.vue?vue&type=script&lang=js"
export * from "./imprimirCierre.vue?vue&type=script&lang=js"
import style1 from "./imprimirCierre.vue?vue&type=style&index=1&id=04121a5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports